<template>
  <page-error title="404" :subtitle="message" :error="error"></page-error>
</template>

<script>
import PageError from "@/views/PageError";
export default {
  name: "Page404",
  components: {
    PageError
  },
  props: {
    message: {
      type: String,
      default: "Not found"
    },
    error: {
      type: Error,
      default: null
    }
  }
};
</script>
